import {Component, TemplateRef, ViewChild} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {NgbModalRef} from '@ng-bootstrap/ng-bootstrap/modal/modal-ref';
import {TranslateService} from '@ngx-translate/core';
import {AssignmentModel} from '../../../models/assignment.model';
import {StructureDepartmentModel} from '../../../models/department.model';
import {ModalSettingsModel} from '../../../models/modal.model';
import {IAssignmentExecutor, UserTasksSettings} from '../../../models/task.model';
import {BoardGroupModel, BoardTableModel, TaskBoardModel, TaskTypesModel} from '../../../models/tasktable.model';
import {MemberModel} from '../../../models/user.model';
import {CrmService} from '../../../services/api/crm.service';
import {DepartmentsService} from '../../../services/api/departments.service';
import {HelpersService} from '../../../services/helpers.service';
import {MemberService} from '../../../services/member.service';
import {ModalService} from '../../../services/modal/modal.service';
import {AlertService} from '../../../services/notify/alert.service';
import {TaskServiceService} from '../../../services/task-service.service';
import {DialogsMTService} from '../../../services/modal/dialogs-mt.service';
import {catchError, EMPTY, filter, switchMap} from 'rxjs';

@Component({
    selector: 'app-detail-assignments',
    templateUrl: './detail-assignments.component.html',
    styleUrls: ['./detail-assignments.component.scss']
})
export class DetailAssignmentsComponent {
    @ViewChild('taskView') public viewTask: TemplateRef<any>;

    assignmentId: number;
    assignment: AssignmentModel;

    tab: string = 'global';
    addExecutorTab: 'user' | 'department' | 'division' = 'user';

    createTaskDescription: string = null;
    changeBoard: TaskBoardModel;
    selectedType: TaskTypesModel;
    dashes: BoardTableModel[];
    selectedDash: BoardTableModel = null;
    taskAlias: string = null;
    colons: UserTasksSettings[] = [
        {alias: 'task_alias', hidden: false, model: null, name: '#'},
        {alias: 'title', hidden: false, model: null, name: 'Title'},
        {alias: 'content', hidden: false, model: null, name: 'Task content'},
        {alias: 'comments_count', hidden: false, model: null, name: 'Number of comments'},
        {alias: 'contract_guid', hidden: false, model: null, name: 'Contract'},
        {alias: 'due_time', hidden: false, model: null, name: 'Time for execution'},
        {alias: 'duration', hidden: false, model: null, name: 'Duration'},
        {alias: 'importance', hidden: false, model: null, name: 'Importance'},
        {alias: 'importance_index', hidden: false, model: null, name: 'importance index'},
        {alias: 'status_current', hidden: false, model: null, name: 'Status'},
        {alias: 'created_at', hidden: false, model: null, name: 'Created at'},
        {alias: 'updated_at', hidden: false, model: null, name: 'Updated at'},
        {alias: 'deadline_at', hidden: false, model: null, name: 'Deadline'},
        {alias: 'task_type', hidden: false, model: null, name: 'Task type'},
        {alias: 'roles', hidden: false, model: null, name: 'Roles'},
        {alias: 'user_roles', hidden: false, model: null, name: 'User roles'},
    ];

    allMembers: MemberModel[] = [];
    allDepartments: StructureDepartmentModel[] = [];
    selectedDepartmentWithDivisions: StructureDepartmentModel;
    divisionSlider: {
        [key: number]: boolean
    } = {};
    executorKey: number | string;

    statuses = {
        'new': 'Новое',
        'in_progress': 'В процессе',
        'executed': 'Исполнено',
        'archived': 'Архив'
    };

    constructor(
        private activeRouter: ActivatedRoute,
        private router: Router,
        private taskService: CrmService,
        private taskHelperService: TaskServiceService,
        private memberService: MemberService,
        private alertService: AlertService,
        private translate: TranslateService,
        private departmentsApi: DepartmentsService,
        public helpers: HelpersService,
        public modalService: ModalService,
        private dialogsMTService: DialogsMTService
    ) {
        this.activeRouter.params.subscribe(params => {
            this.assignmentId = params['id'];
            this.getAssignment();
        });
    }

    getAssignment(): void {
        this.taskService.getAssignmentById(this.assignmentId).subscribe((res) => {
            this.assignment = res.assignment;
            this.updateAssignmentUsers();
        });
    }

    updateAssignmentUsers() {
        let allUsersGuids: string[] = this.assignment.executors.user;
        allUsersGuids.push(this.assignment.author_guid);
        this.memberService.memberGuidsHandler(allUsersGuids).then((res) => {
            this.assignment.author = res.find(x => x.guid === this.assignment.author_guid);
            this.assignment.executors.usersModels = res.filter(x => x.guid !== this.assignment.author_guid);
        });
    }

    openAddExecutorModal(template: TemplateRef<any>): void {
        this.memberService.getAllMembers().then((res) => {
            this.modalService.openTemplateModal(template);
            this.allMembers = res;
        });

        this.departmentsApi.getStructureDepartments().subscribe({
            next: res => {
                this.allDepartments = res.departments;
            }
        });
    }

    addExecutor(modal: NgbModalRef): void {
        this.taskService.addExecutorForAssignment(this.assignmentId, {
            executor_id: this.executorKey,
            executor_type: this.addExecutorTab
        }).subscribe({
            next: () => {
                this.getAssignment();
                modal.close();
            }, error: err => {
                this.alertService.setAlert(err.message, 'blue');
            }
        });
    }

    delExecutor(user: MemberModel): void {
        let dataToDelete: IAssignmentExecutor = {
            executor_id: user.guid,
            executor_type: 'user'
        }
        this.dialogsMTService.confirmDialog({
            actionHeader: 'CONFIRM.HEADERS.ATTENTION',
            actionBody: 'CONFIRM.TEXT.DELETE_ASSIGNMENT_EXECUTOR'
        })
            .pipe(
                filter(res => res.isConfirmed),
                switchMap(() => this.taskService.delExecutorForAssignment(this.assignmentId, dataToDelete)
                    .pipe(
                        catchError((err) => {
                            this.alertService.setAlert(err.message, 'blue');
                            return EMPTY
                        })
                    )),
                catchError(() => {
                    return EMPTY
                }))
            .subscribe(res => {
                this.assignment = res.assignment
                this.updateAssignmentUsers();
                this.alertService.setAlert(this.translate.instant('ALERTS.ASSIGNMENT_EXECUTOR_DELETED'), 'green')
            })
    }

    editAssignment(key: string, value: string): void {
        console.log(value);
        const data = {};

        data[key] = value;

        this.taskService.editAssignment(this.assignmentId, data).subscribe({
            next: () => {
                this.getAssignment();
            }, error: err => {
                this.alertService.setAlert(err.message, 'blue');
            }
        });
    }

    changeAssignmentStatus(status: string): void {
        this.taskService.changeAssignmentStatus(status, this.assignmentId).subscribe({
            next: () => {
                this.getAssignment();
            }, error: err => {
                this.alertService.setAlert(err.message, 'blue');
            }
        });
    }

    selectBoard(board: BoardTableModel): void {
        this.taskHelperService.getBoard(board.alias, true).then(res => {
            this.changeBoard = res.board;
            this.selectedType = this.changeBoard.task_types[0];
        });
    }

    deleteAssignment(): void {
        const modalSettings: ModalSettingsModel = {
            modalHeader: 'Удалить',
            modalBody: 'Удалить поручение <b>' + this.assignment.title + '</b>?',
            buttonSubmit: 'Да',
            buttonClose: 'Нет',
        };

        const modal = this.modalService.createFromSettings(modalSettings);
        modal.result.then(data => {
            if (data) {
                this.taskService.deleteAssignmentById(this.assignmentId).subscribe({
                    next: () => {
                        this.router.navigate(['account/assignments/all']);
                    }, error: err => {
                        this.alertService.setAlert(err.message, 'blue');
                    }
                });
            }
        }).catch(() => {
            return;
        });
    }

    openCreateTaskModal(content: TemplateRef<any>): void {
        this.taskHelperService.getAllBoards(false).then(result => {
            this.dashes = result.boards.filter(onlyBoard => onlyBoard.rights && onlyBoard.rights.is_create_new_task);
            result.groups.map((x: BoardGroupModel) => {
                const boardsWithPermissions = x.boards.filter(groupBoard =>
                    groupBoard.rights && groupBoard.rights.is_create_new_task);
                this.dashes = this.dashes.concat(boardsWithPermissions);
            });

        });
        this.modalService.openTemplateModal(content);
    }

    onCreateTask(modal: NgbModalRef, name: string): void {
        const taskData = {
            title: name,
            content: this.createTaskDescription,
            board_alias: this.selectedDash.alias,
            task_type_id: this.selectedType.id,
            assignment_id: this.assignmentId,
        };

        this.taskService.createTask(taskData).subscribe({
            next: data => {
                modal.close();
                this.alertService.setAlert(this.translate.instant('ALERTS.SUCCESS'), 'green');
                this.changeBoard = null;
                this.selectedType = null;
                this.selectedDash = null;
                this.taskAlias = data.task.task_alias;
                console.log(this.taskAlias);
                this.getAssignment();
                setTimeout(() => {
                    this.modalService.openTemplateModal(this.viewTask, 'xl');
                });
            }, error: error => {
                this.alertService.setAlert(error.message, 'blue');
            },
        });
    }
}
